/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_No_TargetInputs */

const cs_pipelines_no_target = /** @type {(inputs: Pipelines_No_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejprve vytvořte jinou pipeline.`)
};

const en_pipelines_no_target = /** @type {(inputs: Pipelines_No_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create another pipeline first.`)
};

/**
* | output |
* | --- |
* | "Create another pipeline first." |
*
* @param {Pipelines_No_TargetInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_no_target = /** @type {((inputs?: Pipelines_No_TargetInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_No_TargetInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_no_target(inputs)
	return cs_pipelines_no_target(inputs)
});